import Vue from 'vue'
import App from './App.vue'
import '@/styles/reset.css';
import '@/styles/iconfont.css';
import '@/styles/iconfont2.css';
import { bpoTip } from "@/utils/bpo.js";
import { getStorage, setStorage, removeStorage, FormatTime, isJsonString,getQueryString } from '@/utils/util.js'
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'

// 聊天模块的js引入
import WebIM from '@/utils/WebIM.js';
Vue.use(WebIM)
Vue.prototype.$IM = WebIM;
Vue.prototype.$query = getQueryString;
// 添加一些公共原型链方法
Vue.prototype.$toast = bpoTip;
Vue.prototype.$setStorage = setStorage;
Vue.prototype.$getStorage = getStorage;
Vue.prototype.$removeStorage = removeStorage;
Vue.prototype.$formatTime = FormatTime;
Vue.prototype.$isJsonString = isJsonString;

var option = {
    // maxSpreadZoom: 1, // 控制预览图最大的倍数，默认是2倍，我这里改成了原图
   fullscreenEl: false, //控制是否显示右上角全屏按钮cl
    // closeEl: false, //控制是否显示右上角关闭按钮
    tapToClose: false, //点击滑动区域应关闭图库
    // shareEl: false, //控制是否显示分享按钮
    zoomEl: true, //控制是否显示放大缩小按钮
    counterEl: true, //控制是否显示左上角图片数量按钮
    arrowEl: true,  //控制如图的左右箭头（pc浏览器模拟手机时）
    // tapToToggleControls: true, //点击应切换控件的可见性
    clickToCloseNonZoomable: false, //点击图片应关闭图库，仅当图像小于视口的大小时
    closeOnScroll: false,
    bgOpacity: 0.5,
  }
Vue.use(preview,option)

import Viewer from "v-viewer"
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer, {
    defaultOptions: {
        zIndex: 9999
    },
    Options: {
        "inline": true,
        "button": true,
        "navbar": true,
        "title": true,
        "toolbar": true,
        "tooltip": true,
        "movable": true,
        "zoomable": true,
        "rotatable": true,
        "scalable": false,
        "transition": true,
        "fullscreen": true,
        "keyboard": true,
        "url": "data-source"
    }
})

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);


import router from './router/index'

import './utils/filter'
import './router/fliter'
import store from './store'
import menuFliter from './store/fliter'

Vue.config.productionTip = false

import divMethods from '@/utils/metheds'
Vue.use(divMethods)

// import myEchartsTool from "@/utils/echartsTool"
// Vue.prototype = Object.assign(Vue.prototype,{
//   $echarts: myEchartsTool
// })

// import './components/index.js'

menuFliter().then(() => {
    if (window.poenLoading) {
        document.getElementById('main-loading').className = 'main-loading-end'
        setTimeout(() => {
            document.getElementById('main-loading').style.display = 'none'
        }, 200)
    }
    if (!window.ifStopRenderVue) {
        new Vue({
            router,
            store,
            render: h => h(App),
        }).$mount('#insupai-erp')
    }
}).catch(error => {
    console.log(1, error)
})

Vue.filter('formatPrice', function(value) {
    //格式化价格
    var num = 0;
    if (!isNaN(Number(value))) {
        num = Number(value);
    }
    return num.toFixed(2);
});